import { useState } from "react";
import { ImageIcon, Maximize2 } from "lucide-react";
import { useLang, pick } from "@/lib/i18n";
import { useSite } from "@/lib/site";
import { fileUrl } from "@/lib/api";
import { SectionHead } from "@/components/site/Contact";
import Lightbox from "./Lightbox";

export default function Gallery() {
  const { t, lang } = useLang();
  const { site } = useSite();
  const all = site?.photos || [];
  const heroId = (all.find((p) => p.is_hero) || all[0])?.id;
  const photos = all.length > 1 ? all.filter((p) => p.id !== heroId) : all;
  const [open, setOpen] = useState(null);

  return (
    <section id="gallery" className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-10 lg:py-28" data-testid="gallery-section">
      <SectionHead eyebrow={t("gallery.eyebrow")} title={t("gallery.title")} sub={photos.length ? t("gallery.tap") : t("gallery.empty")} />
      {photos.length ? (
        <div className="flex flex-wrap justify-center gap-3" data-testid="gallery-grid">
          {photos.map((p, i) => (
            <button key={p.id} onClick={() => setOpen(i)} data-testid={`gallery-photo-${i}`}
              className="group relative block w-full overflow-hidden rounded-xl border border-white/10 bg-[#111318] sm:w-[calc((100%-1.5rem)/3)]">
              <img src={fileUrl(p.thumb_path || p.storage_path)} alt={pick(p, "caption", lang) || "RECORDING ROOM"} loading="lazy" decoding="async"
                width={p.width} height={p.height} className="block h-auto w-full transition-transform duration-500 group-hover:scale-[1.03]" />
              <span className="absolute right-2 top-2 rounded-full bg-black/60 p-1.5 text-white opacity-0 transition-opacity group-hover:opacity-100"><Maximize2 size={14} /></span>
              {pick(p, "caption", lang) && (
                <span className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/85 to-transparent p-3 text-left text-xs text-white sm:text-sm">{pick(p, "caption", lang)}</span>
              )}
            </button>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
          {[0, 1, 2, 3].map((i) => (
            <div key={i} className="brackets flex aspect-[4/3] flex-col items-center justify-center gap-2 rounded-xl border border-dashed border-white/15 bg-white/[0.02] text-slate-500">
              <ImageIcon size={22} /><span className="font-mono text-[11px] uppercase tracking-widest">{t("gallery.soon")}</span>
            </div>
          ))}
        </div>
      )}
      {open !== null && <Lightbox photos={photos} index={open} onIndex={setOpen} onClose={() => setOpen(null)} />}
    </section>
  );
}
